// ─────────────────────────────────────────────────────────────────────
// Bug-report config.
//
// BUG_REPORT_EMAIL comes from the Infisical-injected VITE_BUG_REPORT_EMAIL,
// baked into the client bundle at build time — see vite.config.ts and
// CLAUDE.md "Secrets". It is referenced by NAME only; no value lives in source.
// It is only the address the report dialog offers for a MANUAL send (the
// mailto button and the copy fields).
//
// WEB3FORMS IS RETIRED (#1142, owner decision 2026-11-02). The browser used
// to mail a copy of every report through Web3Forms with a key baked into the
// bundle. Every report is stored server-side (#1048), and the API now mails
// the heads-up itself, through its own mail driver, to `BUG_REPORT_EMAIL` on
// the SERVER (`apps/api/src/bugs/report.ts`). So the key, the endpoint and
// the CSP entry for api.web3forms.com are gone — do not bring them back.
// ─────────────────────────────────────────────────────────────────────

export const BUG_REPORT_EMAIL = import.meta.env.VITE_BUG_REPORT_EMAIL;
